import Checkbox from './Checkbox';

export default Checkbox;


//////////////////
// WEBPACK FOOTER
// ./~/rc-checkbox/es/index.js
// module id = 686
// module chunks = 14